import { datasourceTypeIds } from '../../../Datasets/IngestSettings/components/IncrementalIngestionSettings/utilities/IncrementalIngestionsSettings.constants';
import { initIngestionSchedule } from '../../../DataSourceForms/helpers/getDataSourceIngestionSchedule';
import {
  IDataSourceTypesResponse,
  TDataSource,
} from 'Modules/Studio/DataSources/redux/initialState';

export const COMMON_FORM_CONFIG_DEFAULTS = {
  name: '',
  id: null,
  connectionUrl: null,
  userName: '',
  password: '',
  ingestionSchedule: [],
  profiles: null,
};

const GoogleBigQueryForm = (selectedDatasourceType: IDataSourceTypesResponse): TDataSource => {
  return Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    props: {},
    dataSourceType: datasourceTypeIds.GOOGLE_BIG_QUERY,
    connectionUrl: selectedDatasourceType?.connectionUrl || '',
    ingestionSchedule: initIngestionSchedule(),
  });
};

const DbForm = (selectedDatasourceType: IDataSourceTypesResponse): TDataSource => {
  return Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    props: {},
    dataSourceType: selectedDatasourceType.id,
    schema: selectedDatasourceType?.schema || '',
    connectionUrl: selectedDatasourceType?.connectionUrl || '',
    ingestionSchedule: initIngestionSchedule(),
  });
};

const DataBricksForm = (selectedDatasourceType: IDataSourceTypesResponse): TDataSource => {
  return Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    props: {},
    dataSourceType: datasourceTypeIds.DATA_BRICKS,
    connectionUrl: selectedDatasourceType?.connectionUrl || '',
    ingestionSchedule: initIngestionSchedule(),
  });
};

const S3CsvForm = (dataSourceType: number): TDataSource =>
  Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    dataSourceType,
    props: {
      accessId: '',
      accessSecret: '',
      bucket: '',
      filePattern: '',
      folder: '',
      region: '',
      headerRow: '',
      dataRow: '',
      delimiter: '',
    },
    ingestionSchedule: initIngestionSchedule(),
  });

const LocalFilesForm = (dataSourceType: number): TDataSource =>
  Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    dataSourceType,
    props: {
      headerRow: '',
      dataRow: '',
      delimiter: '',
      fileName: null,
    },
    ingestionSchedule: initIngestionSchedule(),
  });

const AzureFilesForm = (dataSourceType: number): TDataSource =>
  Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    dataSourceType,
    props: {
      storageAccountUrl: '',
      sasToken: '',
      container: '',
      folder: '',
      filePattern: '',
      region: '',
      headerRow: '',
      dataRow: '',
      delimiter: '',
    },
    ingestionSchedule: initIngestionSchedule(),
  });

const KobaiAPIForm = (): TDataSource =>
  Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    dataSourceType: datasourceTypeIds.KOBAI_API,
    props: {
      dataUrl: 'https://',
      xApiKey: '',
    },
    ingestionSchedule: [],
  });

const APIForm = (): TDataSource =>
  Object.assign({}, COMMON_FORM_CONFIG_DEFAULTS, {
    dataSourceType: datasourceTypeIds.API,
    props: {
      baseURL: '',
      responseType: '',
      authType: '',
    },
    ingestionSchedule: [],
  });

export const getDataSourceFormConfigs = {
  DataBricksForm,
  DbForm,
  S3CsvForm,
  LocalFilesForm,
  GoogleBigQueryForm,
  AzureFilesForm,
  KobaiAPIForm,
  APIForm,
};
